<template>
	<section>
		<div class="top">
			<el-input
				style="float: right; width: 200px"
				class="search"
				clearable
				v-model="keyword"
				size="mini"
				:placeholder="this.$t('productAll.aliasSearch')"
			></el-input>
		</div>

		<el-table ref="productsTable" :data="allProducts" style="width: 100%" :empty-text="this.$t('productAll.noData')">
			<el-table-column prop="name" :label="this.$t('productAll.productName')"></el-table-column>
			<el-table-column prop="alias" :label="this.$t('productAll.productAlias')"></el-table-column>
			<el-table-column
				prop="category_name"
				:label="this.$t('productAll.category')"
				:filters="filterCategoryName"
				:filter-method="filterCategory"
			></el-table-column>
			<el-table-column
				prop="status"
				:label="this.$t('productAll.state')"
				:filters="[
					{ text: this.$t('productAll.enable'), value: 1 },
					{ text: this.$t('productAll.disable'), value: 0 },
				]"
				:filter-method="filterStatus"
			>
				<template slot-scope="scope">
					<span>{{ scope.row.status ? $t("productAll.enable") : $t("productAll.disable") }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="cz" :label="this.$t('productAll.operate')">
				<template slot-scope="scope">
					<el-button size="mini" @click="handleEdit(scope.row)">{{ $t("productAll.edit") }}</el-button>
					<el-button type="primary" size="mini" @click="handleHistory(scope.row)">{{ $t("productAll.insert") }}{{ $t("common.history") }}</el-button>
				</template>
			</el-table-column>
		</el-table>

		<el-pagination
			class="pagination"
			background
			layout="prev, pager, next"
			:page-size="meta.per_page"
			:total="meta.total"
			:current-page="meta.current_page"
			@current-change="handleCurrentChange"
		>
		</el-pagination>

		<!-- 商品编辑 -->
		<ProductEdit
			:editProductDialogFormVisible="editProductDialogFormVisible"
			:editProductDialogForm="editProductDialogForm"
			:attributeOptions="attributeOptions"
			@handle-close-edit-product="handleCloseEditProduct"
			@handle-update-specification="handleUpdateSpecification"
			@handle-confirm-product-edit="handleConfirmProductEdit"
		></ProductEdit>
	</section>
</template>
<script>
import ProductEdit from "./product-edit.vue";
import { putImportHistory } from "@/services/api-v2/api-v2";

export default {
	components: {
		ProductEdit,
	},
	props: {
		productCount: {
			type: Number,
			required: true,
			default: 0,
		},
		allProducts: {
			type: Array,
			required: true,
			default: [],
		},
		attributeOptions: {
			type: Array,
			required: true,
			default: [],
		},
		meta: {
			type: Object,
			required: true,
			default: {},
		},
	},
	data() {
		return {
			//搜索关键词
			keyword: "",

			// 编辑商品弹出框
			editProductDialogFormVisible: false,

			// 编辑商品表单数据
			editProductDialogForm: {
				productId: "",
				name: "",
				alias: "",
				categoryName: "",
				attributeOptions: [],
				selectedAttributes: [],
				status: null,
				index: "",
			},
		};
	},
	computed: {
		//筛选类别数据
		filterCategoryName() {
			return _.map(_.groupBy(this.allProducts, "category_name"), (_item, key) => ({ text: key, value: key }));
		},
	},
	watch: {
		keyword() {
			this.$emit("handle-search", this.keyword);
		},
	},
	methods: {
		// 点击所有商品页面分页事件
		handleCurrentChange(currentPage) {
			this.$emit("handle-current-change", currentPage);
		},

		// 关闭编辑弹出框
		handleCloseEditProduct() {
			this.editProductDialogFormVisible = false;
		},

		// 商品信息编辑
		handleEdit(data) {
			this.editProductDialogFormVisible = true;
			this.editProductDialogForm.productId = data.id;
			this.editProductDialogForm.name = data.name;
			this.editProductDialogForm.alias = data.alias;
			this.editProductDialogForm.categoryName = data.category_name;
			this.editProductDialogForm.attributeOptions = data.attribute_options.map((item) => item.id);
			this.editProductDialogForm.status = data.status;
			this.editProductDialogForm.selectedAttributes = data.selected_attributes;
			this.editProductDialogForm.index = this.productAllData.findIndex((item) => {
				return item.id === data.id;
			});
		},

		// 添加规格
		handleUpdateSpecification() {
			this.$emit("handle-update-specification");
		},

		//确定编辑
		handleConfirmProductEdit(data) {
			this.$emit("handle-confirm-product-edit", data);
		},

		// 类别筛选
		filterCategory(value, row) {
			return row.category_name === value;
		},

		// 状态筛选
		filterStatus(value, row) {
			return row.status === value;
		},

		// 插入history
		async handleHistory(row) {
			try {
				await putImportHistory(this.$route.params.id, row.id);
				this.$message.success(this.$t("productAll.insertingSuccessfully"));
			} catch (error) {
				this.$message.error(error);
			}
		},
	},
};
</script>
<style scoped>
.top {
	padding-top: 10px;
}
.pagination {
	padding: 20px 0;
	display: flex;
	justify-content: flex-end;
}
</style>
